export const API_KEY = "AIzaSyAZenYtmS3khVd8GB8p9N1V9sfCHQkKz0E";

export default API_KEY;